module.exports = __webpack_public_path__ + "img/ez-casino-payment-bank-citi.fefda17a.png";